import { useContext } from "react";
import { OrganizationAppsLinkingPage } from "../../../../Apps/pages/Linking/pages/components/LinkList";
import { LinkingListType } from "../../../../Apps/pages/Linking/services/types";
import ProductContext from "../../../pages/Index/pages/Edit";

export const OrganizationProductAppLinksPage = () => {
	const productContext = useContext(ProductContext);
	const id = productContext.product?.id;

	return <OrganizationAppsLinkingPage listType={LinkingListType.PRODUCT_APP_LINK} productId={id} />;
};
